import React from "react";
import icon1 from "../assets/shipwhite.png";
import icon11 from "../assets/shipblue.png";
import icon3 from "../assets/holidayschedulewhite.png";
import icon2 from "../assets/cctvwhite.png";
import icon8 from "../assets/trafficinformationwhite.png";
import icon9 from "../assets/logisticsshipwhite.png";
import blueIcon2 from "../assets/cctvblue.png";
import blueIcon3 from "../assets/holidayscheduleblue.png";
import utasBlue from "../assets/utasblue.png";
import utasWhite from "../assets/utaswhite.png";
import blueIcon8 from "../assets/trafficinformationblue.png";
import blueIcon9 from "../assets/logisticsshipblue.png";
import blueTruck from "../assets/trucksblue.png";
import whiteTruck from "../assets/truckswhite.png";
import nineIcon1 from "../assets/eriwhite.png";
import nineIcon11 from "../assets/eriblue.png";
import historicalIcon1 from "../assets/historicalIconWhite.png";
import historicalIcon11 from "../assets/historicalIconBlue.png";
import oceanmapwhite from "../assets/oceanmapwhite.png";
import oceanmapblue from "../assets/oceanmapblue.png";
import dwellwhite from "../assets/dwellwhite.png";
import dwellblue from "../assets/dwellblue.png";
import weatherwhite from "../assets/weatherwhite.png";
import weatherblue from "../assets/weatherblue.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../App.css";
import { languageJson } from "../StringVariable";
class Tools extends React.Component {
  state = {
    firstIcon: false,
    secondIcon: false,
    thirdIcon: false,
    fourthIcon: false,
    fifthIcon: false,
    sixthIcon: false,
    seventhIcon: false,
    eigthIcon: false,
    nineIcon: false,
    tenIcon: false,
    elevenIcon: false,
    twelveIcon: false,
  };

  render() {
    return (
      <>
        <section className="tools-section">
          <div className="row">
            <div className="col-12  center-head-underline d-flex justify-content-center py-5">
              <motion.h1
                className="text-center  f-head"
                initial={{ opacity: 0, scale: 0.3 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, ease: "easeOut", delay: 0.1 }}
                viewport={{ once: false, amount: 0.2 }}
              >
                {languageJson.sectionName["tolls&services"]}
              </motion.h1>
            </div>
          </div>
          <div className="container-fluid p-5 pt-5 min-vh-75 tools-background-image color-overlay">
            <div className="container">
              <div className="row pb-5 tools-row1 pt-5">
                <div className="col-md-3  col-xs-12 col-sm-6">
                  <center className="">
                    <Link to="/vesselOperation" className="card-link">
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.3,
                          ease: "easeOut",
                          delay: 0.1,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ firstIcon: true })}
                        onMouseLeave={() => this.setState({ firstIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.firstIcon ? icon11 : icon1}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.vesselOperation}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.firstIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.vesselOperationDes}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>

                <div className="col-md-3 col-xs-12 col-sm-6">
                  <center>
                    <Link
                      to={{
                        pathname: "/LogisticsMap",
                      }}
                      className="card-link"
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.2,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ fifthIcon: true })}
                        onMouseLeave={() => this.setState({ fifthIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.fifthIcon ? blueIcon9 : icon9}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.LogisticsMap.logistics_map_title_txt}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.fifthIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.LogisticsMap.logistics_map_title_desc}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>

                <div className="col-md-3 col-xs-12 col-sm-6">
                  <center>
                    <Link to="/PortHolidayCalendar" className="card-link">
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.3,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ sixthIcon: true })}
                        onMouseLeave={() => this.setState({ sixthIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.sixthIcon ? blueIcon3 : icon3}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.port_holiday_calendar_title}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.sixthIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.port_holiday_calendar_desc}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>
                <div className="col-md-3 col-xs-12 col-sm-6 ">
                  <center>
                    <Link to="/EmptyReturnInstructions" className="card-link">
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.4,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ nineIcon: true })}
                        onMouseLeave={() => this.setState({ nineIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.nineIcon ? nineIcon11 : nineIcon1}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.empty_return_instructions_txt}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.nineIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.empty_return_instructions_desc}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>
              </div>

              <div className="row pt-5 tools-row1 pt-5">
                <div className="col-md-3 col-xs-12 col-sm-6 ">
                  <center>
                    <Link to="/cameras" className="card-link">
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.5,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ eigthIcon: true })}
                        onMouseLeave={() => this.setState({ eigthIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.eigthIcon ? blueIcon2 : icon2}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.truckRoutes}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.eigthIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.truckRoutesDes}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>
                <div className="col-md-3 col-xs-12 col-sm-6">
                  <center>
                    <Link to="/trafficCameras" className="card-link">
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.6,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ secondIcon: true })}
                        onMouseLeave={() =>
                          this.setState({ secondIcon: false })
                        }
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.secondIcon ? blueIcon8 : icon8}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson["traffic&Cameras"]}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.secondIcon ? "show" : ""
                            }`}
                          >
                            {languageJson["traffic&CamerasDes"]}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>

                <div className="col-md-3  col-xs-12 col-sm-6">
                  <center className="">
                    <Link
                      to="/aggregate-dwell-by-week/b0a8fcee-b840-4d1d-b139-4892a3122ece"
                      className="card-link"
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.7,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ elevenIcon: true })}
                        onMouseLeave={() =>
                          this.setState({ elevenIcon: false })
                        }
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.elevenIcon ? dwellblue : dwellwhite}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.aggregate_dwell_title}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.elevenIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.aggregate_dwell_desc}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>

                <div className="col-md-3 col-xs-12 col-sm-6">
                  <center>
                    <a
                      href="https://portoakland.emodal.com/"
                      className="card-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", display: "block" }}
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.8,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ fourthIcon: true })}
                        onMouseLeave={() =>
                          this.setState({ fourthIcon: false })
                        }
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.fourthIcon ? utasBlue : utasWhite}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.utas_title}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.fourthIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.utas_desc}
                          </p>
                        </div>
                      </motion.div>
                    </a>
                  </center>
                </div>
              </div>

              <div className="row pt-5 tools-row1 pt-5">
                <div className="col-md-3 col-xs-12 col-sm-6 ">
                  <center>
                    <Link
                      to={{
                        pathname: "/ViewTruckTurnTimes",
                        state: "historicalTruckTurnTime",
                      }}
                      className="card-link"
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.5,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() =>
                          this.setState({ seventhIcon: true })
                        }
                        onMouseLeave={() =>
                          this.setState({ seventhIcon: false })
                        }
                      >
                        <div className="card-image-container">
                          <img
                            src={
                              this.state.seventhIcon
                                ? historicalIcon11
                                : historicalIcon1
                            }
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.Historical_txt}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.seventhIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.historicalTurnTimeDescription}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>
                <div className="col-md-3 col-xs-12 col-sm-6">
                  <center>
                    <Link
                      to="/OaklandOceanCarrierServices"
                      className="card-link"
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.6,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ tenIcon: true })}
                        onMouseLeave={() => this.setState({ tenIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={
                              this.state.tenIcon ? oceanmapblue : oceanmapwhite
                            }
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson.ocean_services_text_title}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.tenIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.ocean_services_desc}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>

                <div className="col-md-3  col-xs-12 col-sm-6">
                  <center className="">
                    <Link
                      to={{
                        pathname: "/trafficCameras",
                        state: "weather",
                      }}
                      className="card-link"
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.7,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ twelveIcon: true })}
                        onMouseLeave={() =>
                          this.setState({ twelveIcon: false })
                        }
                      >
                        <div className="card-image-container">
                          <img
                            src={
                              this.state.twelveIcon ? weatherblue : weatherwhite
                            }
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">{languageJson.weather}</h6>
                          <p
                            className={`card-description ${
                              this.state.twelveIcon ? "show" : ""
                            }`}
                          >
                            {languageJson.weatherDes}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>

                <div className="col-md-3 col-xs-12 col-sm-6">
                  <center>
                    <Link
                      to="/TruckRoutesComplianceInformation"
                      className="card-link"
                    >
                      <motion.div
                        className="card-container"
                        initial={{ opacity: 0, scale: 0.3 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeOut",
                          delay: 0.8,
                        }}
                        viewport={{ once: false, amount: 0.2 }}
                        onMouseEnter={() => this.setState({ thirdIcon: true })}
                        onMouseLeave={() => this.setState({ thirdIcon: false })}
                      >
                        <div className="card-image-container">
                          <img
                            src={this.state.thirdIcon ? blueTruck : whiteTruck}
                            alt="icon"
                            className="card-image"
                          />
                        </div>
                        <div className="card-content">
                          <h6 className="card-title">
                            {languageJson["security&safety"]}
                          </h6>
                          <p
                            className={`card-description ${
                              this.state.thirdIcon ? "show" : ""
                            }`}
                          >
                            {languageJson["security&safetyDes"]}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Tools;
